import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as BusLineStopActions from '../../actions/master-data/bus-line-stops.actions';

@Injectable()
export class BusLineStopEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) { }
  loadBusLineStops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineStopActions.loadBusLineStops),
      mergeMap(() =>
        this.masterDataService.getAllBusLineStops().pipe(
          map((busLineStops) => BusLineStopActions.loadBusLineStopsSuccess({ busLineStops })),
          catchError((error) => of(BusLineStopActions.loadBusLineStopsFailure({ error })))
        )
      )
    )
  );

  addBusLineStop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineStopActions.addBusLineStop),
      mergeMap(({ busLineStop }) =>
        this.masterDataService.addNewBusLineStop(busLineStop).pipe(
          map(() => BusLineStopActions.loadBusLineStops()),
          catchError((error) => of(BusLineStopActions.loadBusLineStopsFailure({ error })))
        )
      )
    )
  );

  updateBusLineStop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineStopActions.updateBusLineStop),
      mergeMap(({ busLineStop }) =>
        this.masterDataService.updateBusLineStop(busLineStop).pipe(
          map(() => BusLineStopActions.loadBusLineStops()),
          catchError((error) => of(BusLineStopActions.loadBusLineStopsFailure({ error })))
        )
      )
    )
  );  

  deleteBusLineStop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineStopActions.deleteBusLineStop),
      mergeMap(({ id }) =>
        this.masterDataService.deleteBusLineStop(Number(id)).pipe(
          map(() => BusLineStopActions.loadBusLineStops()),
          catchError((error) => of(BusLineStopActions.loadBusLineStopsFailure({ error })))
        )
      )
    )
  );
  
}